export default __webpack_public_path__ + "static/media/4.d5a1ce36.jpg";